export const clients = {
  table: {
    id: 'ID',
    name: 'Name',
    lastPingAt: 'Last Ping At',
    isOffline: 'Is Offline',
    offline: 'Offline',
    online: 'Online',
    detailDevice: 'Detail Device',
    date: 'Date',
    status: 'Status',
  },
  pageHeader: {
    title: 'List Device',
    titleDetail: 'Device Detail',
    titleListDetailError: 'List Device Error',
  },
}
